import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { deleteAccountExpensePolicyRulesAsync, getAccountExpensePolicyRuleByExpensePolicyRuleIdAsync,checkedState, unCheckedState, checkedAllState, unCheckedAllState, updateAccountExpensePolicyRulesAsync,updateSorting } from './expensePolicyRuleSlice';
import { Link } from 'react-router-dom';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import { useTranslation } from "react-i18next";
import ExpensePolicyRuleForm from './ExpensePolicyRuleForm';
import { useNavigate } from 'react-router-dom';
import clsx from "clsx";
import { setItemStatus, getValueFromResource, FormatInvoiceDecimalNumber} from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';

const ExpensePolicyRuleItem = (props: any) => {
    const { modelRef, expensePolicyRuleList,onopenModal, IsEdit, IsDelete } = props;    
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { isLoading,sortOrder, sortColumn, pageSize  } = useAppSelector((state) => state.expensePolicyRule);    
        const { cultureInfoName, decimalFormat, decimalPlaces } = useAppSelector((state) => state.globalState);
    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };
    const onEditClick = (AccountExpensePolicyRuleId: number) => {
        dispatch(getAccountExpensePolicyRuleByExpensePolicyRuleIdAsync(AccountExpensePolicyRuleId))
            .unwrap()
            .then((originalPromiseResult) => {
                modelRef.current.click();
            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('getAccountExpensePolicyRuleByExpensePolicyRuleIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }

    const onDeleteClick = (AccountExpensePolicyRuleId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountExpensePolicyRulesAsync(AccountExpensePolicyRuleId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            ShowToast("Expense policy rule deleted Successfully", 'Success', "success", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            console.log('onDeleteClick-deleteExternalUserAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
    }
   

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, AccountExpenseRule: any) => {
        const { checked } = e.target;
        const foundIndex = expensePolicyRuleList.findIndex((item: any) => item.AccountExpensePolicyRuleId === AccountExpenseRule.AccountExpensePolicyRuleId);
        if (foundIndex !== -1) {
            const foundItem = expensePolicyRuleList[foundIndex];
            const {  ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...expensePolicyRuleList.slice(0, foundIndex), updatedItem, ...expensePolicyRuleList.slice(foundIndex + 1)];
            dispatch(updateAccountExpensePolicyRulesAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("Expense Policy Rule Updated Successfully", 'Success', "success", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
    }
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }


    return (
        <>
        
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                     
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={expensePolicyRuleList.every((item: any) => item.isSelected === 0) ? false :
                                            (expensePolicyRuleList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                            <th style={{ width: '15%' }}>
                                {/* {t('Active / Inactive')} */}
                                {getValueFromResource('Active / Inactive',dispatch, t)}
                            {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th> 
                        <th style={{ width: '20%' }}>
                            {/* {t('Rule Name')} */}
                            {getValueFromResource('Rule Name',dispatch, t)}
                        {sortColumn === 'PolicyRuleName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "PolicyRuleName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "PolicyRuleName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "PolicyRuleName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "PolicyRuleName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Category')} */}
                            {getValueFromResource('Category',dispatch, t)}
                        {sortColumn === 'ExpenseType' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ExpenseType") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ExpenseType") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ExpenseType") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ExpenseType") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Rule Type')} */}
                            {getValueFromResource('Rule Type',dispatch, t)}
                        {sortColumn === 'SystemExpenseRuleTypeName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemExpenseRuleTypeName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemExpenseRuleTypeName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemExpenseRuleTypeName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemExpenseRuleTypeName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Limit Type')} */}
                            {getValueFromResource('Limit Type',dispatch, t)}
                        {sortColumn === 'SystemExpenseLimitTypeName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemExpenseLimitTypeName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemExpenseLimitTypeName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemExpenseLimitTypeName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemExpenseLimitTypeName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Value')} */}
                            {getValueFromResource('Value',dispatch, t)}
                        {sortColumn === 'PolicyRuleValue' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "PolicyRuleValue") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "PolicyRuleValue") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "PolicyRuleValue") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "PolicyRuleValue") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {/* <th className='w-10'>{t('Active / Inactive')}</th>     */}
                        <th className='w-5 text-center'></th>                                       
                    </tr>
                </thead>
                <tbody>
                     {expensePolicyRuleList.length === 0 && <tr><td colSpan={7}><p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}
                        </p></td></tr>}
                     {expensePolicyRuleList.length > 0 && expensePolicyRuleList.map((expensePolicyRuleDetail: any, i: any) => (
                        <tr key={i}>
                            
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check "
                                            checked={expensePolicyRuleDetail.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, expensePolicyRuleDetail.AccountExpensePolicyRuleId) }}

                                        />
                                    </div>
                                </td>
                             <td>
                                 <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(expensePolicyRuleDetail.IsDisabled === false ? "Active" : "InActive"))}>
                                     {expensePolicyRuleDetail.IsDisabled === false ? "Active" : "InActive"}
                                 </span>
                             </td>
                            <td>                                
                            <a id="kt_OffCanvas"
                                    className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => { onEditClick(expensePolicyRuleDetail.AccountExpensePolicyRuleId)}}>                                   
                                    {expensePolicyRuleDetail.PolicyRuleName} 
                                </a>
                            </td>
                            <td>
                                {expensePolicyRuleDetail.AccountExpenseName == undefined ? expensePolicyRuleDetail.ExpenseType + " (Expense Type)" : expensePolicyRuleDetail.AccountExpenseName}
                            </td>
                            <td><span className="">{expensePolicyRuleDetail.SystemExpenseRuleTypeName}</span></td>
                            <td><span className="">{expensePolicyRuleDetail.SystemExpenseLimitTypeName}</span></td>
                            <td><span className="">{FormatInvoiceDecimalNumber(cultureInfoName.toString(), expensePolicyRuleDetail.PolicyRuleValue, decimalPlaces)}</span></td>
                            {/* <td className='text-center'>
                                <div className="form-check form-switch form-check-custom">
                                    <input
                                        type="checkbox"
                                        className="form-check-input custom-padding-right h-15px w-30px"
                                        id="IsDisabled"
                                        checked={expensePolicyRuleDetail.IsDisabled === true ? true : false}
                                        onChange={(e) => { handleIsDisabledChange(e, expensePolicyRuleDetail) }}
                                    />
                                    
                                </div>
                            </td> */}
                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                            <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                id="kt_OffCanvas" 
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => { onEditClick(expensePolicyRuleDetail.AccountExpensePolicyRuleId) }}
                                                                >
                                                                    <span className="menu-icon custom-menu">
                                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {/* {`${t('Edit')}`} */}
                                                                        {getValueFromResource('Edit',dispatch, t)}
                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>                                                  
                                                        <div className='separator mb-1 mt-1 opacity-75 '></div>                                                
                                                  
                                                            <div className='menu-hover-bg-danger'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => { onDeleteClick(expensePolicyRuleDetail.AccountExpensePolicyRuleId) }}
                                                                    >
                                                                    <span className="menu-icon  custom-menu">
                                                                        <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                        {/* {`${t('Delete')}`} */}
                                                                        {getValueFromResource('Delete',dispatch, t)}
                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                </Dropdown.Menu>
                                            </Dropdown>
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
 
}

export default ExpensePolicyRuleItem